import { RuleProps } from 'types/application';

export const DEALER_LICENCE = 'dealer-licence';
export const DEALERS_CONTACT_PERSON_PARTICULARS = 'dealers-contact-person-particulars';
export const DEALERS_LICENCE_MAILING_ADDRESS = 'dealers-licence-mailing-address';
export const OTHER_DETAILS = 'other-details';
export const EQUIPMENT_INFORMATION = 'equipment-information';
export const RADIO_INFORMATION = 'radio-information';
export const EQUIPMENT_DETAILS_FREQUENCY = 'equipment-details-frequency';

export const IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS = 'imda-ts-security-requirements-for-residential-gateways';
export const IMDA_TS_RG_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT = 'imda-ts-rg-sec-4-1-login-credentials-management';
export const IMDA_TS_RG_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS = 'imda-ts-rg-sec-4-1-1-factory-pre-loaded-login-credentials';
export const IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH = 'imda-ts-rg-sec-4-1-2-minimum-password-strength';
export const IMDA_TS_RG_SEC_4_2_2_AUTH_HANDLING = 'imda-ts-rg-sec-4-2-2-auth-handling';
export const IMDA_TS_RG_SEC_4_2_DEVICE_SETUP_AND_ADMINISTRATION = 'imda-ts-rg-sec-4-2-device-setup-and-administration';
export const IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS = 'imda-ts-rg-sec-4-2-1-device-pre-loaded-settings';
export const IMDA_TS_RG_SEC_4_2_2_INITIAL_SETUP_HANDLING = 'imda-ts-rg-sec-4-2-2-initial-setup-handling';
export const IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING = 'imda-ts-rg-sec-4-2-3-authentication-handling';
export const IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING = 'imda-ts-rg-sec-4-2-4-credentials-handling';
export const IMDA_TS_RG_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE = 'imda-ts-rg-sec-4-2-5-device-management-interface';
export const IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES = 'imda-ts-rg-sec-4-3-firmware-updates';
export const IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION = 'imda-ts-rg-sec-4-4-wireless-access-protection';
export const IMDA_TS_RG_SEC_4_4_DATA_PROTECTION = 'imda-ts-rg-sec-4-4-data-protection';
export const IMDA_TS_RG_SEC_4_5_LEVEL2_REQUIREMENTS = 'imda-ts-rg-sec-4-5-level2-requirements';
export const IMDA_TS_RG_SEC_4_6_VALIDATION_OF_DATA_INPUTS = 'imda-ts-rg-sec-4-6-validation-of-data-inputs';
export const IMDA_TS_RG_SEC_4_7_VULNERABILITIES_REPORTING = 'imda-ts-rg-sec-4-7-vulnerabilities-reporting';

export const CYBERSECURITY_LABELLING_SCHEME = 'cybersecurity-labelling-scheme';

export const IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION = 'imda-ts-security-requirements-for-pabx';
export const IMDA_TS_PABX_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT = 'imda-ts-pabx-sec-4-1-login-credentials-management';
export const IMDA_TS_PABX_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS = 'imda-ts-pabx-sec-4-1-1-factory-pre-loaded-login-credentials';
export const IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH = 'imda-ts-pabx-sec-4-1-2-minimum-password-length';
export const IMDA_TS_PABX_SEC_4_2_DEVICE_SETUP_AND_ADMINISTRATION = 'imda-ts-pabx-sec-4-2-device-setup-and-administration';
export const IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS = 'imda-ts-pabx-sec-4-2-1-device-pre-loaded-settings';
export const IMDA_TS_PABX_SEC_4_2_2_INITIAL_SETUP_HANDLING = 'imda-ts-pabx-sec-4-2-2-initial-setup-handling';
export const IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING = 'imda-ts-pabx-sec-4-2-3-authentication-handling';
export const IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING = 'imda-ts-pabx-sec-4-2-4-password-handling';
export const IMDA_TS_PABX_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE = 'imda-ts-pabx-sec-4-2-5-device-management-interface';
export const IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES = 'imda-ts-pabx-sec-4-3-firmware-updates';
export const IMDA_TS_PABX_SEC_4_4_DATA_PROTECTION = 'imda-ts-pabx-sec-4-4-data-protection';
export const IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY = 'imda-ts-pabx-sec-4-4-1-data-confidentiality';
export const IMDA_TS_PABX_SEC_4_4_2_EVENT_NOTIFICATION = 'imda-ts-pabx-sec-4-4-2-event-notification';
export const IMDA_TS_PABX_SEC_4_4_3_DATA_BACKUP = 'imda-ts-pabx-sec-4-4-3-data-backup';
export const IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK = 'imda-ts-pabx-sec-4-5-securing-the-trunk';
export const IMDA_TS_PABX_SEC_4_6_VALIDATION_OF_DATA_INPUTS = 'imda-ts-pabx-sec-4-6-validation-of-data-inputs';
export const IMDA_TS_PABX_SEC_4_7_REPORTING = 'imda-ts-pabx-sec-4-7-reporting';
export const IMDA_TS_PABX_SEC_4_7_1_REPORT_ON_CALLS = 'imda-ts-pabx-sec-4-7-1-report-on-calls';
export const IMDA_TS_PABX_SEC_4_7_2_VULNERABILITY_REPORTING = 'imda-ts-pabx-sec-4-7-2-vulnerability-reporting';

export const AMEND_ESER_LICENCE = [
    {
        sectionID: DEALER_LICENCE,
        sectionName: '',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'dealer-licence-no',
                label: 'Dealer Licence No.',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-dealer-licence-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-dealer-licence-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'dealer-licence-company-name',
                label: "Dealer's Licence Company Name",
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-dealer-licence-company-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-dealer-licence-company-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'scheme-type',
                label: 'Scheme Type',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-scheme-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-scheme-type`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'brand-trade-name',
                label: 'Brand/Trade Name',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-brand-trade-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-brand-trade-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'model-no',
                label: 'Model No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-model-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-model-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'equipment-description',
                label: 'Equipment Description',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-equipment-description`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-equipment-description`] === '-');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: DEALERS_CONTACT_PERSON_PARTICULARS,
        sectionName: 'Dealer Contact Person Particulars',
        fieldList: [
            {
                id: 'same-as-applicant-particulars',
                label: 'Same as Applicant Particulars',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-same-as-applicant-particulars`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-same-as-applicant-particulars`] === '-'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-designation`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-designation`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-email`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-email`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'office-tel-number',
                label: 'Office Tel Number',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-office-tel-number`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-office-tel-number`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'mobile-number',
                label: 'Mobile Number',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-mobile-number`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-mobile-number`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'fax-number',
                label: 'Fax Number',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-fax-number`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-fax-number`] === '-');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: DEALERS_LICENCE_MAILING_ADDRESS,
        sectionName: "Dealer's Licence Mailing Address",
        fieldList: [
            {
                id: 'same-as-applicant-particulars',
                label: 'Same as Applicant Particulars',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`] === '-'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-unit`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-unit`] === '-');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'other-details',
                label: '',
                type: 'text',
                span: 12,
                rule: {
                    hidden: true
                }
            },
            {
                id: 'public-contact-no',
                label: 'Public Contact No.',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${OTHER_DETAILS}-public-contact-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${OTHER_DETAILS}-public-contact-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${OTHER_DETAILS}-remarks`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${OTHER_DETAILS}-remarks`] === '-');
                        return result;
                    }
                }
            }
        ],
        rule: {
            baseIds: [`${OTHER_DETAILS}-other-details`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${OTHER_DETAILS}-other-details`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_INFORMATION,
        sectionName: 'Equipment Information',
        fieldList: [
            {
                id: 'imda-spec-no-desc',
                label: 'IMDA Spec No./Desc.',
                type: 'lists',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_INFORMATION}-imda-spec-no-desc`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value: any = baseValues && baseValues[`${EQUIPMENT_INFORMATION}-imda-spec-no-desc`];
                        const result = Boolean(value.length === 0);
                        return result;
                    }
                }
            },
            {
                id: 'list-of-telecommunication-interface-cards',
                label: 'List of Telecommunication Interface Cards (Optional)',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_INFORMATION}-list-of-telecommunication-interface-cards`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${EQUIPMENT_INFORMATION}-list-of-telecommunication-interface-cards`] === '-'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'network-connection',
                label: 'Network Connection',
                type: 'lists',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_INFORMATION}-network-connection`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value: any = baseValues && baseValues[`${EQUIPMENT_INFORMATION}-network-connection`];
                        const result = Boolean(value.length === 0);
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: RADIO_INFORMATION,
        sectionName: 'Radio Information',
        fieldList: [
            {
                id: 'equipment',
                label: 'Equipment',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${RADIO_INFORMATION}-equipment`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${RADIO_INFORMATION}-equipment`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'equipment-category',
                label: 'Equipment Category',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${RADIO_INFORMATION}-equipment-category`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${RADIO_INFORMATION}-equipment-category`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'equipment-type',
                label: 'Equipment Type',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${RADIO_INFORMATION}-equipment-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${RADIO_INFORMATION}-equipment-type`] === '-');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: EQUIPMENT_DETAILS_FREQUENCY,
        sectionName: 'Equipment Details - Frequency',
        fieldList: [
            {
                id: 'equipment-details-frequency',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'sn',
                        header: 'S/N',
                        type: 'text'
                    },
                    {
                        id: 'frequency-band',
                        header: 'Frequency Band (Maximum Radiated Power/Field Strength)',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ],
        rule: {
            baseIds: [`${RADIO_INFORMATION}-equipment`],
            hidden: ({ baseValues }: RuleProps) => {
                const bla = baseValues && baseValues[`${RADIO_INFORMATION}-equipment`];
                const result = Boolean(
                    baseValues &&
                    baseValues[`${RADIO_INFORMATION}-equipment`] !== 'Radio (Others e.g. DVB-T2 IRD)' &&
                    baseValues[`${RADIO_INFORMATION}-equipment`] !== 'Both Line & Radio' &&
                    baseValues[`${RADIO_INFORMATION}-equipment`] !== 'Residential Gateway'
                );
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS,
        sectionName: 'IMDA TS Security Requirements for Residential Gateways',
        fieldList: [
            {
                id: 'residential-gateways',
                label: '',
                type: 'text',
                span: 12,
                rule: {
                    hidden: true
                }
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH,
        sectionName: 'IMDA TS RG-SEC § 4.1 Minimum Password Strength',
        fieldList: [
            {
                id: '4-1-a',
                label: '4.1.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-1-b',
                label: '4.1.b CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-1-c',
                label: '4.1.c CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_RG_SEC_4_2_DEVICE_SETUP_AND_ADMINISTRATION,
        sectionName: 'IMDA TS RG-SEC 4.2 Device Setup & Administration',
        fieldList: [],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS,
        sectionName: 'IMDA TS RG-SEC 4.2.1 Factory Pre-loaded Login Credentials',
        fieldList: [
            {
                id: '4-2-1-a',
                label: '4.2.1.a CR:C',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-1-b',
                label: '4.2.1.b CR:C',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING,
        sectionName: 'IMDA TS RG-SEC 4.2.2 Authentication Handling',
        fieldList: [
            {
                id: '4-2-2-a',
                label: '4.2.2.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-2-b',
                label: '4.2.2.b CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-2-c',
                label: '4.2.2.c CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING,
        sectionName: 'IMDA TS RG-SEC 4.2.3 Credentials Handling',
        fieldList: [
            {
                id: '4-2-3-a',
                label: '4.2.3.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-3-b',
                label: '4.2.3.b CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-3-c',
                label: '4.2.3.c CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES,
        sectionName: 'IMDA TS RG-SEC 4.3 Firmware Updates',
        fieldList: [
            {
                id: '4-3-a',
                label: '4.3.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-3-b',
                label: '4.3.b CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_RG_SEC_4_4_DATA_PROTECTION,
        sectionName: 'IMDA TS RG-SEC 4.4 Data Protection',
        fieldList: [
            {
                id: '4-4-a',
                label: '4.4 CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_RG_SEC_4_5_LEVEL2_REQUIREMENTS,
        sectionName: 'IMDA TS RG-SEC 4.5 CLS Level2 Requirements',
        fieldList: [
            {
                id: '4-5',
                label: '4.5 CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: CYBERSECURITY_LABELLING_SCHEME,
        sectionName: 'Cybersecurity Labelling Scheme',
        fieldList: [
            {
                id: 'cybersecurity-labelling-scheme',
                label: '',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${CYBERSECURITY_LABELLING_SCHEME}-cybersecurity-labelling-scheme`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(
                    baseValues && baseValues[`${CYBERSECURITY_LABELLING_SCHEME}-cybersecurity-labelling-scheme`] === '-'
                );
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION,
        sectionName: 'IMDA TS Security Requirements for PABX Declaration Section',
        fieldList: [
            {
                id: 'pabx',
                label: '',
                type: 'text',
                span: 12,
                rule: {
                    hidden: true
                }
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT,
        sectionName: 'IMDA TS PABX-SEC 4.1 - Login Credentials Management',
        fieldList: [],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS,
        sectionName: 'IMDA TS PABX-SEC 4.1.1 - Factory Pre-Loaded Login Credentials',
        fieldList: [
            {
                id: '4-1-1-pabx',
                label: '4.1.1 CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH,
        sectionName: 'IMDA TS PABX-SEC 4.1.2 - Minimum Password Length',
        fieldList: [
            {
                id: '4-1-2-a-pabx',
                label: '4.1.2.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-1-2-b-pabx',
                label: '4.1.2.b CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-1-2-c-pabx',
                label: '4.1.2.c CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_2_DEVICE_SETUP_AND_ADMINISTRATION,
        sectionName: 'IMDA TS PABX-SEC 4.2 Device Setup & Administration',
        fieldList: [],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS,
        sectionName: 'IMDA TS PABX-SEC 4.2.1 Device Pre-loaded Settings',
        fieldList: [
            {
                id: '4-2-1-a-pabx',
                label: '4.2.1.a CR:C',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-1-b-pabx',
                label: '4.2.1.b CR:C',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-1-c-pabx',
                label: '4.2.1.c CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-1-d-pabx',
                label: '4.2.1.d CR:C',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_2_2_INITIAL_SETUP_HANDLING,
        sectionName: 'IMDA TS PABX-SEC 4.2.2 Initial Setup Handling',
        fieldList: [
            {
                id: '4-2-2-pabx',
                label: '4.2.2 CR:V',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING,
        sectionName: 'IMDA TS PABX-SEC 4.2.3 Authentication Handling',
        fieldList: [
            {
                id: '4-2-3-a-pabx',
                label: '4.2.3.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-3-b-pabx',
                label: '4.2.3.b CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-3-c-pabx',
                label: '4.2.3.c CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-3-d-pabx',
                label: '4.2.3.d CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING,
        sectionName: 'IMDA TS PABX-SEC 4.2.4 Password Handling',
        fieldList: [
            {
                id: '4-2-4-a-pabx',
                label: '4.2.4.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-2-4-b-pabx',
                label: '4.2.4.b CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE,
        sectionName: 'IMDA TS PABX-SEC 4.2.5 Device Management Interface',
        fieldList: [
            {
                id: '4-2-5-pabx',
                label: '4.2.5 CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES,
        sectionName: 'IMDA TS PABX-SEC 4.3 Firmware Updates',
        fieldList: [
            {
                id: '4-3-a-pabx',
                label: '4.3.a CR:C',
                type: 'text',
                span: 12
            },
            {
                id: '4-3-b-pabx',
                label: '4.3.b CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-3-c-pabx',
                label: '4.3.c CR:V',
                type: 'text',
                span: 12
            },
            {
                id: '4-3-d-pabx',
                label: '4.3.d CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-3-e-pabx',
                label: '4.3.e CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-3-f-pabx',
                label: '4.3.f CR:V',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_4_DATA_PROTECTION,
        sectionName: 'IMDA TS PABX-SEC 4.4 Data Protection',
        fieldList: [],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY,
        sectionName: 'IMDA TS PABX-SEC 4.4.1 Data Confidentiality',
        fieldList: [
            {
                id: '4-4-1-a-pabx',
                label: '4.4.1.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-4-1-b-pabx',
                label: '4.4.1.b CR:C',
                type: 'text',
                span: 12
            },
            {
                id: '4-4-1-c-pabx',
                label: '4.4.1.c CR:C',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_4_2_EVENT_NOTIFICATION,
        sectionName: 'IMDA TS PABX-SEC 4.4.2 Event Notification',
        fieldList: [
            {
                id: '4-4-2-pabx',
                label: '4.4.2 CR:V',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_4_3_DATA_BACKUP,
        sectionName: 'IMDA TS PABX-SEC 4.4.3 Data Backup',
        fieldList: [
            {
                id: '4-4-3-pabx',
                label: '4.4.3 CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK,
        sectionName: 'IMDA TS PABX-SEC 4.5 Securing the Trunk',
        fieldList: [
            {
                id: '4-5-a-pabx',
                label: '4.5.a CR:M',
                type: 'text',
                span: 12
            },
            {
                id: '4-5-b-pabx',
                label: '4.5.b CR:C',
                type: 'text',
                span: 12
            },
            {
                id: '4-5-c-pabx',
                label: '4.5.c CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_6_VALIDATION_OF_DATA_INPUTS,
        sectionName: 'IMDA TS PABX-SEC 4.6 Validation of Data Inputs',
        fieldList: [
            {
                id: '4-6-pabx',
                label: '4.6 CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_7_REPORTING,
        sectionName: 'IMDA TS PABX-SEC 4.7 Reporting',
        fieldList: [],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_7_1_REPORT_ON_CALLS,
        sectionName: 'IMDA TS PABX-SEC 4.7.1 Report on Calls',
        fieldList: [
            {
                id: '4-7-1-pabx',
                label: '4.7.1 CR:M',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: IMDA_TS_PABX_SEC_4_7_2_VULNERABILITY_REPORTING,
        sectionName: 'IMDA TS PABX-SEC 4.7.2 Vulnerability Reporting',
        fieldList: [
            {
                id: '4-7-2-pabx',
                label: '4.7.2 CR:C',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    }
];
